// Generated by Melange

import * as Json__Json_encode from "melange-json/Json_encode.js";

function encode(paginate) {
  const limit = paginate.limit;
  if (limit !== undefined) {
    return Json__Json_encode.object_({
      hd: [
        "page",
        paginate.page
      ],
      tl: {
        hd: [
          "limit",
          limit
        ],
        tl: /* [] */ 0
      }
    });
  } else {
    return null;
  }
}

function toTuple(paginate) {
  return [
    "paginate",
    encode(paginate)
  ];
}

const $$default = {
  page: 1,
  limit: undefined
};

export {
  encode,
  toTuple,
  $$default as default,
}
/* No side effect */
